import { getQueryStringData, translation as t } from "../../inc/helpers.js";
import LocaleSwitch from "../components/LocaleSwitch.js";
import Modal from "../components/Modal.js";
import PanelDonate from "../components/PanelDonate.js";
import SiteHeader from "../components/SiteHeader.js";

export default class PageCommon {
    constructor() { }

    init($data) {
        $(".js-logout").on("click", this.doLogout.bind(this));

        this.initBtnsToggleDonatePanel();
        this.initSiteHeader();
        this.initLocaleSwitch();
        this.checkTransaction();

        // dispaccio un evento globale
        try {
            this.dispatchInitEvent(TheDisp.EV_PAGECOMMON_INITED);
        } catch (error) {
            console.log(error);
        }
    }

    initBtnsToggleDonatePanel() {
        const btns = document.querySelectorAll(".js-toggle-donate-panel");
        btns?.forEach(btn => {
            const uid = btn.dataset?.uid;
            btn.addEventListener("click", this.initPanelDonate.bind(this, uid, btn));            
        });
    }

    initPanelDonate(uid, btn) {
        clearTimeout(this._panelDebouncer);
        document.querySelector(".dialog-donate.is-visible")?.remove();

        const targets = [document.querySelector(".app")];
        const panel = document.getElementById("template-dialog-donate").cloneNode(true);

        if (!panel) return;

        panel.removeAttribute("id");
        const panelDonate = new PanelDonate({
            panel,
            onOpen: () => {
                this.lockPageScroll(true);
                this.lockTargets(targets, true);

                if (btn.closest(".nav-voicelist") && !btn.parentNode.classList.contains("is-active"))
                    btn.parentNode.classList.add("is-active");
            },
            onClose: (panel) => {
                clearTimeout(this._panelDebouncer);
                this._panelDebouncer = setTimeout(() => {
                    panel.remove();
                    this.lockPageScroll(false);
                    this.lockTargets(targets, false);

                    btn?.parentNode?.classList.contains("is-active")
                        && btn.parentNode.classList.remove("is-active");
                }, 250);
            },
            setLoading: this.showPreloader.bind(this),
            showModal: this.showModal.bind(this)
        });

        window.addEventListener("keydown", (e) => e.key === "Escape" && panelDonate.hide());

        if (uid?.length > 0)
            panelDonate.project = uid;

        panelDonate.init();

        document.body.appendChild(panel);
        this._panelDebouncer = setTimeout(() => panelDonate.show(), 50);
    }

    initLocaleSwitch() {
        const btn = document.querySelector(".js-btn-toggle-locale-list");
        const container = document.querySelector(".js-locale-list");
        const list = container?.querySelector(".locale-list-voices");
        const localeSwitch = new LocaleSwitch({ container, btn, list });
        const header = document.querySelector(".js-site-header");
        localeSwitch.render();
        header?.addEventListener("click", (e) => localeSwitch.closeSwitch());
    }

    initSiteHeader() {
        const targets = [
            document.querySelector(".main-content"),
            document.querySelector(".site-footer")
        ];
        const header = document.querySelector(".js-site-header");
        const btn = header?.querySelector(".js-btn-toggle-menu");
        const siteHeader = new SiteHeader({
            header,
            btn,
            onOpen: () => {
                this.lockTargets(targets, true);
                this.lockPageScroll(true);
            },
            onClose: () => {
                this.lockTargets(targets, false);
                this.lockPageScroll(false);
            }
        });
    }

    lockPageScroll(bool) {
        if (bool) {
            if (!document.body.classList.contains("overflow-hidden"))
                document.body.classList.add("overflow-hidden");

        } else
            document.body.classList.remove("overflow-hidden");
    }

    lockTargets(targets, bool) {
        if (bool) {
            targets?.forEach(t => t?.setAttribute("inert", ""));
            return;
        }

        targets?.forEach(t => t?.removeAttribute("inert"));
    }

    checkTransaction() {
        const qs = getQueryStringData();
        if (qs?.transaction)
            this.showModal(t("lblDonationSuccessTitle"), t("lblDonationSuccessMessage"), true);
    }

    showModal(title, body, refreshpage = false) {
        const targets = [document.querySelector(".app")];
        let modal;
        const m = document.getElementById("template-modal")?.cloneNode(true);
        m.removeAttribute("id");
        const btnConfirm = document.createElement("button");
        btnConfirm.classList.add("btn", refreshpage ? "btn-modal-confirm" : "btn-modal-close");
        btnConfirm.setAttribute("aria-label", refreshpage ? t("lblConfirm") : t("lblClose"));
        btnConfirm.setAttribute("autofocus", "");
        btnConfirm.textContent = refreshpage ? t("lblConfirm") : t("lblClose");
        btnConfirm.addEventListener("click", () => modal.hide());

        modal = new Modal({
            modal: m,
            siblings: [document.querySelector(".app")],
            title: title,
            body: body,
            buttons: [btnConfirm],
            onOpen: () => {
                const prev = document.querySelector("body > .modal-default");
                if (prev !== m)
                    prev?.remove();

                this.lockPageScroll(true);
                this.lockTargets(targets, true);
            },
            onClose: () => {
                if (refreshpage) {
                    this.showPreloader(true);
                    window.location.href = TheApp.Env.BaseUrlNls;
                }

                modal.hide();
                const bool =
                    document.querySelector(".dialog-donate.is-visible")
                        ? true
                        : false;
                this.lockPageScroll(bool);
                this.lockTargets(targets, false);
            }
        });

        window.addEventListener("keydown", (e) => e.key === "Escape" && modal.hide());

        document.body.appendChild(m);
        modal.show();
    }

    dispatchInitEvent(evenTyepe) {
        // dispaccio un evento globale
        let ev = new Event(evenTyepe);
        ev.payload = { page: this }
        TheDisp.dispatchEvent(ev);
    }

    get isHomepage() {
        return false;
    }

    doLogout() {
        AuthWiz.doLogout("/");
    }

    showPreloader(flag, percent = null) {
        if (flag) {
            if (percent == null) {
                $(".js-percent", $(".js-preloader")).hide();
            } else {
                $(".js-percent", $(".js-preloader")).show();
                $(".js-percent", $(".js-preloader")).text(percent);
            }
            jQuery(".js-preloader").show();
        } else {
            jQuery(".js-preloader").hide();
        }
    }

    static showPreloader(flag, percent = null) {
        if (flag) {
            if (percent == null) {
                $(".js-percent", $(".js-preloader")).hide();
            } else {
                $(".js-percent", $(".js-preloader")).show();
                $(".js-percent", $(".js-preloader")).text(percent);
            }
            jQuery(".js-preloader").show();
        } else {
            jQuery(".js-preloader").hide();
        }
    }

    static disable(mc, lFlag, opacity = 0.5) {
        if (lFlag) {
            mc.css("pointer-events", "none");
            mc.css("opacity", opacity);
        } else {
            mc.css("pointer-events", "all");
            mc.css("opacity", 1);
        }
    }
}